import {InputDate} from "../../../_services/date-extensions";
import {DateFormat} from "../../../x-models/x-enums/date-format";

export class EventRepetitionModel {
  weekdays: number = 0;
  interval: number = 1;
  intervalCount: number = 1;
  end: InputDate = new InputDate();
  dateFormat: DateFormat = DateFormat.hyphen_yyyyMMdd;

  constructor() {
    // `end` only backs the "Wiederholen bis" date input: a browser-local PICKER date. The series reads just its
    // calendar date (`pickerDateToDayKey`) and resolves every occurrence in the company zone (#658), so this
    // local midnight never reaches the server.
    this.end.setHours(0, 0, 0, 0);
  }

  set(day: number) {
    if ((this.weekdays & day) === day) {
      this.weekdays &= ~day;
    } else {
      this.weekdays |= day;
    }
  }

  contains(day: number): boolean {
    return (this.weekdays & day) === day;
  }
}
